import { render, staticRenderFns } from "./latest-news.vue?vue&type=template&id=6bcf2f38&"
import script from "./latest-news.vue?vue&type=script&lang=js&"
export * from "./latest-news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports